<div class="data-container">
    <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name='meliitemcontainer'>
    </ngx-spinner>

    <div class="form-toolbar">
        <nz-steps [nzCurrent]="currentStep" nzSize="small" class="wizard-steps">
            <nz-step *ngFor="let step of visibleSteps; let i = index; trackBy: trackStep" [nzTitle]="step.title|translateTA" (click)="currentStep=i" class="step-clickable"></nz-step>
        </nz-steps>
        <div class="form-toolbar-actions">
            <nz-select class="columns-select" nzSize="small" [ngModel]="formColumns" (ngModelChange)="onColumnsChange($event)"
                nz-tooltip [nzTooltipTitle]="'meli.form.columns'|translateTA">
                <nz-option [nzValue]="0" [nzLabel]="'meli.form.columnsAuto'|translateTA"></nz-option>
                <nz-option [nzValue]="1" [nzLabel]="'1 ' + ('meli.form.column'|translateTA)"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'2 ' + ('meli.form.columnsLabel'|translateTA)"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'3 ' + ('meli.form.columnsLabel'|translateTA)"></nz-option>
                <nz-option [nzValue]="4" [nzLabel]="'4 ' + ('meli.form.columnsLabel'|translateTA)"></nz-option>
            </nz-select>
            <button nz-button nzDanger (click)="sair()">{{'meli.form.exit'|translateTA}}</button>
            <button nz-button (click)="previousStep()" [disabled]="currentStep===0">{{'meli.form.back'|translateTA}}</button>
            <button nz-button (click)="nextStep()" [disabled]="currentStep===visibleSteps.length-1">{{'meli.form.next'|translateTA}}</button>
            <button nz-button nzType="primary" (click)="salvar()">
                <nz-icon nzType="save" />
                {{'meli.form.save'|translateTA}}
            </button>
        </div>
    </div>

    <!-- ============ Passo: Informação Inicial ============ -->
    <div class="step-content" [hidden]="currentStepId!=='info'">
        <form [formGroup]="formGroup">
            <div class="form-grid" [style.gridTemplateColumns]="gridTemplateColumns">
                <search-input entitydesc="Contratos" entityname="Mktpcontract"
                    [placeholder]="'meli.form.contract'|translateTA" controlname="CODECONTRACT" fieldname="CONTRACTNAME"
                    [columndesc]="'meli.form.contractCode'|translateTA" [form]="formGroup" columnname="CODECONTRACT" [loaddesc]="true">
                </search-input>

                <search-input entitydesc="Empresa" entityname="Mktpcompanies"
                    [placeholder]="'meli.form.company'|translateTA" controlname="CODECOMPANY" fieldname="NAME"
                    [columndesc]="'meli.form.companyCode'|translateTA" [form]="formGroup" columnname="CODECOMPANY" [loaddesc]="true">
                </search-input>

                <search-input entitydesc="Produtos" entityname="Mktpproducts"
                    [placeholder]="'meli.form.product'|translateTA" controlname="CODEPRODUCT" fieldname="NAME"
                    [columndesc]="'meli.form.productCode'|translateTA" [form]="formGroup" columnname="CODEPRODUCT" [loaddesc]="true">
                </search-input>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.mlb'|translateTA}}</span>
                    <input nz-input formControlName="mlb_anuncio" maxlength="60" [placeholder]="'meli.form.mlb'|translateTA" />
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.permlink'|translateTA}}</span>
                    <input nz-input formControlName="permlink" [placeholder]="'meli.form.permlink'|translateTA" />
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.catalogId'|translateTA}}</span>
                    <input nz-input formControlName="catalog_product_id" [placeholder]="'meli.form.catalogId'|translateTA" />
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.title'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-input-group [nzSuffix]="titleSuffix">
                        <input nz-input formControlName="title" maxlength="60" [placeholder]="'meli.form.title'|translateTA" />
                    </nz-input-group>
                    <ng-template #titleSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchTitle'|translateTA"
                            (click)="getDataFromTable(formGroup,'title',$event, '{@getTitleMeli}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('title',formGroup,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.familyName'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="familySuffix">
                        <input nz-input formControlName="FAMILY_NAME" maxlength="120" [placeholder]="'meli.form.familyName'|translateTA" />
                    </nz-input-group>
                    <ng-template #familySuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchTitle'|translateTA"
                            (click)="getDataFromTable(formGroup,'FAMILY_NAME',$event, '{@getTitleMeli}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('FAMILY_NAME',formGroup,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.userProductId'|translateTA}}</span>
                    <input nz-input formControlName="USER_PRODUCT_ID" [placeholder]="'meli.form.userProductId'|translateTA" />
                </div>

                <input-button-popup *ngIf="!byCatalogo"
                    [label]="'meli.form.category'|translateTA"
                    [placeholder]="'meli.form.category'|translateTA"
                    type="text"
                    icon="category"
                    [controle]="formGroup.get('category_id')"
                    required="true"
                    [data]="formGroup"
                    (result)="formSubmitted($event)"
                    [disabled]="disablePredict"
                    [component]="attribComponente">
                    <span suffix>
                        <button nz-button nzType="text" nzShape="circle" nz-tooltip [nzTooltipTitle]="'meli.form.categoryPrediction'|translateTA"
                            (click)="predicaoCategoria($event)" [disabled]="disablePredict">
                            <nz-icon nzType="bulb" />
                        </button>
                    </span>
                </input-button-popup>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.buyingMode'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-select formControlName="buying_mode" nzShowSearch [nzPlaceHolder]="'meli.form.buyingMode'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('buying_mode')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.currency'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-select formControlName="currency_id" nzShowSearch [nzPlaceHolder]="'meli.form.currency'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('currency_id')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.condition'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-select formControlName="item_condition" nzShowSearch [nzPlaceHolder]="'meli.form.condition'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('item_condition')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.listingType'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-select formControlName="listing_type_id" nzShowSearch [nzPlaceHolder]="'meli.form.listingType'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('listing_type_id')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.shipping'|translateTA}} <span class="tem-field-required">*</span></span>
                    <nz-select formControlName="shipping" nzShowSearch [nzPlaceHolder]="'meli.form.shipping'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('shipping')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.fulfillment'|translateTA}}</span>
                    <nz-select formControlName="envfull" nzShowSearch nzAllowClear [nzPlaceHolder]="'meli.form.fulfillment'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('envfull')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.warranty'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="warrantySuffix">
                        <input nz-input formControlName="warranty" [placeholder]="'meli.form.warranty'|translateTA" />
                    </nz-input-group>
                    <ng-template #warrantySuffix>
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('warranty',formGroup,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.video'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="videoSuffix">
                        <input nz-input formControlName="video_id" [placeholder]="'meli.form.video'|translateTA" />
                    </nz-input-group>
                    <ng-template #videoSuffix>
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('video_id',formGroup,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.officialStore'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="storeSuffix">
                        <input nz-input formControlName="official_store_id" [placeholder]="'meli.form.officialStore'|translateTA" />
                    </nz-input-group>
                    <ng-template #storeSuffix>
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('official_store_id',formGroup,$event)" />
                    </ng-template>
                </div>
            </div>
        </form>
    </div>

    <!-- ============ Passo: Multiplicador de Anúncios ============ -->
    <div class="step-content" [hidden]="currentStepId!=='multi'">
        <nz-alert nzType="warning" nzShowIcon class="multi-alert"
            [nzMessage]="'meli.form.multiWarning'|translateTA"
            [nzAction]="multiAction"></nz-alert>
        <ng-template #multiAction>
            <button nz-button nzType="primary" nzSize="small" (click)="buscarDadosMultiTable()">{{'meli.form.fetchData'|translateTA}}</button>
        </ng-template>
        <div class="multi-table-container">
            <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name='melimultitable'>
            </ngx-spinner>
            <meli-edit-form-multi-table [(dataMultiTable)]="dataMultiTable" [dataMultiTableConfig]="dataMultiTableConfig"></meli-edit-form-multi-table>
        </div>
    </div>

    <!-- ============ Passo: + Informações ============ -->
    <div class="step-content" [hidden]="currentStepId!=='more'">
        <div class="form-grid form-grid-single">
            <div class="tem-field">
                <span class="tem-field-label">{{'meli.form.images'|translateTA}}</span>
                <div class="image-tags" *ngIf="images.length > 0">
                    <nz-tag *ngFor="let image of images" nzMode="closeable" (nzOnClose)="removeImage(image)" nz-tooltip [nzTooltipTitle]="image">
                        {{image}}
                    </nz-tag>
                </div>
                <nz-input-group [nzSuffix]="imageSuffix">
                    <input nz-input [formControl]="imageCtrl" [placeholder]="'meli.form.newImage'|translateTA" (keydown.enter)="addImage(); $event.preventDefault()" />
                </nz-input-group>
                <ng-template #imageSuffix>
                    <nz-icon nzType="plus-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.addImage'|translateTA"
                        (click)="addImage()" />
                    <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchImages'|translateTA"
                        (click)="getDataFromTable('images',null,$event, '{@getImagesMeli}', true)" />
                </ng-template>
            </div>

            <div class="tem-field" [formGroup]="formMore">
                <div class="tem-field-label-row">
                    <span class="tem-field-label">{{'meli.form.description'|translateTA}} <span class="tem-field-required">*</span></span>
                    <span class="tem-field-suffix">
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchDescription'|translateTA"
                            (click)="getDataFromTable(formMore,'description',$event, '{@getDescMeli}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('description',formMore,$event)" />
                    </span>
                </div>
                <textarea nz-input formControlName="description" [placeholder]="'meli.form.description'|translateTA"
                    [nzAutosize]="{ minRows: 5, maxRows: 10 }"></textarea>
            </div>
        </div>
    </div>

    <!-- ============ Passo: Dados de Estoque/Preço ============ -->
    <div class="step-content" [hidden]="currentStepId!=='mid'">
        <form [formGroup]="formMid">
            <div class="form-grid" [style.gridTemplateColumns]="gridTemplateColumns">
                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.codLocal'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="codlocalSuffix">
                        <input nz-input formControlName="codlocal" [placeholder]="'meli.form.codLocal'|translateTA" />
                    </nz-input-group>
                    <ng-template #codlocalSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'codlocal',$event, '{@getMeliCodLocal}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('codlocal',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.quantity'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="qtdSuffix">
                        <input nz-input type="number" formControlName="available_quantity" [placeholder]="'meli.form.quantityPlaceholder'|translateTA" />
                    </nz-input-group>
                    <ng-template #qtdSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'available_quantity',$event, '{@getMeliSTK}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('available_quantity',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentStock'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percentstkSuffix">
                        <input nz-input type="number" formControlName="percentstk" [placeholder]="'meli.form.percentStock'|translateTA" />
                    </nz-input-group>
                    <ng-template #percentstkSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'percentstk',$event, '{@getMeliPercentStk}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percentstk',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.stockMultiplier'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="multiplicadorSuffix">
                        <input nz-input type="number" formControlName="multiplicador" [placeholder]="'meli.form.stockMultiplier'|translateTA" />
                    </nz-input-group>
                    <ng-template #multiplicadorSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'multiplicador',$event, '{@getMeliMultiplicador}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('multiplicador',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.codTab'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="codtabSuffix">
                        <input nz-input formControlName="codtab" [placeholder]="'meli.form.codTab'|translateTA" />
                    </nz-input-group>
                    <ng-template #codtabSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'codtab',$event, '{@getMeliCodTab}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('codtab',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.price'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="priceSuffix">
                        <input nz-input type="number" formControlName="price" [placeholder]="'meli.form.price'|translateTA" />
                    </nz-input-group>
                    <ng-template #priceSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchPrice'|translateTA"
                            (click)="getDataFromTable(formMid,'price',$event, '{@getMeliPrice}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('price',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentIncrease'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percacresSuffix">
                        <input nz-input type="number" formControlName="percacres" [placeholder]="'meli.form.percentIncrease'|translateTA" />
                    </nz-input-group>
                    <ng-template #percacresSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'percacres',$event, '{@getMeliPercAcresc}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percacres',formMid,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentDiscount'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percdescontoSuffix">
                        <input nz-input type="number" formControlName="percdesconto" [placeholder]="'meli.form.percentDiscount'|translateTA" />
                    </nz-input-group>
                    <ng-template #percdescontoSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formMid,'percdesconto',$event, '{@getMeliPercDesconto}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percdesconto',formMid,$event)" />
                    </ng-template>
                </div>
            </div>
        </form>
    </div>

    <!-- ============ Passo: Atributos/Termos de Venda ============ -->
    <div class="step-content" [hidden]="currentStepId!=='attrib'">
        <div class="atributo-garantia">
            <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name='meliitemcontainerattrib'>
            </ngx-spinner>
            <div class="links">
                <button nz-button nzType="link" (click)="buscarAtributos()">{{'meli.form.fetchAttributes'|translateTA}}</button>
                <button nz-button nzType="link" (click)="buscarGarantia()">{{'meli.form.fetchTerms'|translateTA}}</button>
                <span class="spacer"></span>
                <label class="switch-label">
                    <nz-switch nzSize="small" [ngModel]="showHiddenAtributo" (ngModelChange)="slideChange($event,'A')"></nz-switch>
                    {{'meli.form.showAllAttributes'|translateTA}}
                </label>
                <label class="switch-label">
                    <nz-switch nzSize="small" [ngModel]="showHiddenGarantia" (ngModelChange)="slideChange($event,'G')"></nz-switch>
                    {{'meli.form.showAllTerms'|translateTA}}
                </label>
            </div>

            <nz-collapse>
                <nz-collapse-panel [nzHeader]="'meli.form.attributes'|translateTA" [nzActive]="true" [nzExtra]="attribExtra">
                    <ng-template #attribExtra><nz-icon nzType="tags" /></ng-template>
                    <div class="attrib-grid">
                        <ng-container *ngFor="let atrib of attribs">
                            <ng-container *ngIf="!checkHidden(atrib,'A')" [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:atrib, type:'A'}"></ng-container>
                        </ng-container>
                    </div>
                </nz-collapse-panel>
                <nz-collapse-panel [nzHeader]="'meli.form.terms'|translateTA" [nzExtra]="termsExtra">
                    <ng-template #termsExtra><nz-icon nzType="gift" /></ng-template>
                    <div class="attrib-grid">
                        <ng-container *ngFor="let garantia of garantias">
                            <ng-container *ngIf="!checkHidden(garantia,'G')" [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:garantia, type:'G'}"></ng-container>
                        </ng-container>
                    </div>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </div>

    <!-- ============ Passo: Variações ============ -->
    <div class="step-content" [hidden]="currentStepId!=='var'">
        <div class="main-variacao">
            <div class="field-vert">
                <button nz-button nzShape="circle" nzType="primary" nz-tooltip [nzTooltipTitle]="'meli.form.addVariation'|translateTA"
                    (click)="addVariacao()" [disabled]="disableAddVar">
                    <nz-icon nzType="plus" />
                </button>
                <button nz-button nzShape="circle" nzDanger nz-tooltip [nzTooltipTitle]="'meli.form.cancelVariation'|translateTA"
                    (click)="cancelarVariacao()" [disabled]="!disableAddVar">
                    <nz-icon nzType="close" />
                </button>
                <button nz-button nzShape="circle" nz-tooltip [nzTooltipTitle]="'meli.form.fetchVariation'|translateTA"
                    (click)="buscarVariacao()">
                    <nz-icon nzType="rollback" />
                </button>
            </div>

            <div class="variacao-container">
                <meli-item-variation
                    [variacoes]="variacoes"
                    [category_id]="formGroup.get('category_id').value"
                    [tipo]="tipoVariacao"
                    [fatherAttribs]="attribs"
                    [colDef]="coldef"
                    [images]="varimage"
                    [maindata]="data"
                    (savingVariacao)="salvandoVariacao($event)">
                </meli-item-variation>
            </div>
        </div>
    </div>

    <!-- ============ Passo: Status ============ -->
    <div class="step-content" [hidden]="currentStepId!=='status'">
        <form [formGroup]="formStatus">
            <div class="form-grid" [style.gridTemplateColumns]="gridTemplateColumns">
                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.status'|translateTA}}</span>
                    <nz-select formControlName="status" [nzPlaceHolder]="'meli.form.status'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('status')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.sendDescription'|translateTA}}</span>
                    <nz-select formControlName="envdescr" [nzPlaceHolder]="'meli.form.sendDescription'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('envdescr')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.sendPictures'|translateTA}}</span>
                    <nz-select formControlName="envpicture" [nzPlaceHolder]="'meli.form.sendPictures'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('envpicture')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.sendAttributes'|translateTA}}</span>
                    <nz-select formControlName="envatrib" [nzPlaceHolder]="'meli.form.sendAttributes'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('envatrib')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.sendVariation'|translateTA}}</span>
                    <nz-select formControlName="envavar" [nzPlaceHolder]="'meli.form.sendVariation'|translateTA">
                        <nz-option *ngFor="let data of dataValue.get('envavar')" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                    </nz-select>
                </div>

                <div class="tem-field form-grid-full">
                    <span class="tem-field-label">{{'meli.form.message'|translateTA}}</span>
                    <textarea nz-input formControlName="message" [placeholder]="'meli.form.message'|translateTA"
                        [nzAutosize]="{ minRows: 5, maxRows: 10 }"></textarea>
                </div>
            </div>
        </form>
    </div>

    <!-- ============ Menu suspenso: campos do multiplicador ============ -->
    <div class="suspended-menu" cdkDrag *ngIf="showMulti">
        <div class="suspended-menu-actions" cdkDragHandle>
            <span>{{'meli.form.multiFields'|translateTA}}</span>
            <span class="spacer"></span>
            <div class="suspended-menu-actions-in">
                <nz-icon nzType="down" [@indicatorRotate]="expanded ? 'expanded': 'collapsed'" (click)="expanded=!expanded" />
            </div>
        </div>
        <div *ngIf="expanded" [@listAnimation] class="suspended-menu-list">
            <div class="suspended-menu-box" *ngFor="let item of dataMultiTableConfig" draggable="true" [attr.data-drag-data]="'{@MULTI_'+item.columnName+'}'" (dragstart)="drag($event)">{{item.columnDesc}}</div>
        </div>
    </div>
</div>

<!-- ============ Card de atributo/termo ============ -->
<ng-template #main let-item let-type="type">
    <div class="attrib-card" [class.attrib-card-required]="isRequired(item,type)">
        <div class="attrib-card-header">
            <span class="attrib-card-title" nz-tooltip [nzTooltipTitle]="item.name == null ? item.descratrib : item.name">
                {{item.name == null ? item.descratrib : item.name}}
            </span>
            <nz-icon nzType="warning" class="attrib-card-warn" *ngIf="checkAtribVar(item)"
                nz-tooltip [nzTooltipTitle]="'meli.form.attribVariationWarning'|translateTA" />
        </div>
        <div class="attrib-card-hint" nz-tooltip [nzTooltipTitle]="item.hint">{{item.hint}}</div>

        <div class="attrib-card-content">
            <!-- Texto -->
            <nz-input-group [nzSuffix]="attribSuffix" *ngIf="(item.value_type=='string' && item.values == null) || item.value_type==null">
                <input nz-input [maxLength]="item.value_max_length == null? 500 : item.value_max_length"
                    [(ngModel)]="item.value_id" (blur)="onBlur(item,type)" [required]="isRequired(item,type)"
                    [CustomValidatorDirective]="attribValidator"
                    [placeholder]="item.name == null ? item.descratrib : item.name" />
            </nz-input-group>

            <!-- Número + unidade -->
            <div *ngIf="item.value_type=='number_unit'" class="multi-field">
                <nz-input-group [nzSuffix]="attribSuffix" class="left">
                    <input nz-input type="number" [(ngModel)]="item.value_id" (blur)="onBlur(item,type)"
                        [required]="isRequired(item,type)" [CustomValidatorDirective]="attribValidator"
                        [placeholder]="item.name == null ? item.descratrib : item.name" />
                </nz-input-group>
                <nz-select class="right" [(ngModel)]="item.value_unit" (nzBlur)="onBlur(item,type)"
                    [CustomValidatorDirective]="attribValidator" nzAllowClear
                    [nzPlaceHolder]="'meli.form.unit'|translateTA">
                    <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.allowed_units"></nz-option>
                </nz-select>
            </div>

            <!-- Número -->
            <nz-input-group [nzSuffix]="attribSuffix" *ngIf="item.value_type=='number'">
                <input nz-input type="number" [(ngModel)]="item.value_id" (blur)="onBlur(item,type)"
                    [required]="isRequired(item,type)" [CustomValidatorDirective]="attribValidator"
                    [placeholder]="item.name == null ? item.descratrib : item.name" />
            </nz-input-group>

            <!-- Lista/boolean/string com opções -->
            <nz-select *ngIf="(item.value_type=='boolean' || item.value_type=='list' || ( item.value_type == 'string' && item.values != null ) )"
                [(ngModel)]="item.value_id" (nzBlur)="onBlur(item,type)" [CustomValidatorDirective]="attribValidator"
                nzShowSearch nzAllowClear class="full"
                [nzPlaceHolder]="item.name == null ? item.descratrib : item.name">
                <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.values"></nz-option>
            </nz-select>

            <ng-template #attribSuffix>
                <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                    (click)="openDataOption(item)" />
            </ng-template>
        </div>
    </div>
</ng-template>
